<template>
  <div class="mediate">
    <Row class="detail-header">
      <span>和解</span>
      <Button
        type="primary" style="margin-left: 15px;"
        @click="edit"
      >修改</Button>
    </Row>
    <Row class="case-content">
      <!-- 和解表单 -->
      <Row v-if="!infoCtrl&&isDetailLoad">
        <Form
          ref="formData" :model="formData"
          :rules="ruleValidate" :disabled="caseState=='TN'"
          :label-width="120" style="height:100%"
        >
          <FormItem label="选择节点" prop="nodeData">
            <RadioGroup v-model="formData.nodeData" @on-change="changeNode">
              <Radio
                v-for="(item,index) in nodeReduceData" :key="index"
                :label="item.nodeIndex"
              >{{ item.name }}</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="和解对象" prop="selectIdArr">
            <Select
              v-if="defaultData.auditState!='E'" v-model="formData.selectIdArr"
              multiple placeholder="请选择对方当事人"
              label-in-value @on-change="getSelectValue"
            >
              <Option
                v-for="item in litigantIdArr" :key="item.id"
                :value="item.id"
              >{{ item.name }}</Option>
            </Select>
            <Row v-else>{{ defaultData.litigantNames }}</Row>
          </FormItem>
          <FormItem label="和解备注" prop="content">
            <Input
              v-model.trim="formData.content" type="textarea"
              :autosize="{minRows: 3,maxRows: 8}" placeholder="请填写和解备注"
            />

          </FormItem>
          <FormItem label="和解金额" prop="amount">
            <my-input
              v-if="defaultData.auditState!='E'"
              append-text="￥"
              :default-data="formData.amount"
              :to-fixed="2"
              @getValue="getInputValue($event,'amount')"
            />
            <Row v-else>{{ common.formateNumber(defaultData.amount || "") }}</Row>
            <Row v-if="isShowAmountTip" style="color: red">*此金额低于行业客单价目标值</Row>
          </FormItem>

          <FormItem
            label="和解结果"
            prop="succeed"
            :rules="{required: true,type:'number',message: '调解结果不能为空', trigger: 'blur'}"
          >
            <RadioGroup v-model="formData.succeed">
              <Radio :label="1">成功</Radio>
              <Radio :label="0">失败</Radio>

            </RadioGroup>

          </FormItem>
          <FormItem
            label="和解协议"
            prop="attachmentList"
            :rules="formData.succeed===1?{required: true,type:'array', message: '和解协议不能为空', trigger: 'blur'}:{type:'array'}"
          >
            <file-upload
              :default-list="defaultList || []"
              :upload-config="{}"
              @getFileList="getAttachmentList($event,'attachmentList')"
            />
          </FormItem>
          <Row class="detail-btn-box">
            <Button
              type="primary" style="margin-right:10px;"
              :disabled="isSubmit" @click="submitNew"
            >保存</Button>
            <Button v-if="defaultData" @click="infoCtrl=true">取消</Button>
          </Row>
        </Form>
      </Row>

      <!-- 和解详情 -->
      <Row v-if="infoCtrl&&isDetailLoad" class="detail-content">
        <template v-if="!defaultData.source">
          <Row><Col span="5" class="left-label">选择节点：</Col><Col span="16" class="right-content">{{ defaultData.prevNodeName || "" }}</Col></Row>
          <Row><Col span="5" class="left-label">和解类型：</Col><Col span="16" class="right-content">线下</Col></Row>
          <Row><Col span="5" class="left-label">和解对象：</Col><Col span="16" class="right-content">{{ defaultData.litigantNames || "" }}</Col></Row>
          <Row><Col span="5" class="left-label">和解备注：</Col><Col span="16" class="right-content">{{ defaultData.content || "" }}</Col></Row>
          <Row><Col span="5" class="left-label">和解金额：</Col><Col span="16" class="right-content">{{ common.formateNumber(defaultData.amount || "") }}</Col></Row>
          <Row v-if="defaultData.lowUnitPriceFlag" style="color: red">
            <Col span="5" class="left-label" />
            <Col span="16" class="right-content">*此金额低于行业客单价目标值</Col>
          </Row>
          <Row v-if="defaultData.auditState">
            <Col span="5" class="left-label">审核结果：</Col>
            <Col span="16" class="right-content">
              <Tag style="border-radius:11px;" :color="getTagColor(defaultData.auditState)">{{ defaultData.auditStateName }}</Tag>
            </Col>
          </Row>
          <Row v-if="defaultData.auditState&&defaultData.auditState!='P'">
            <Col span="5" class="left-label">审核备注：</Col>
            <Col span="16" class="right-content">{{ defaultData.auditRemark }}</Col>
          </Row>
          <Row>
            <Col span="5" class="left-label">和解结果：</Col>
            <Col span="16" class="right-content">{{ getSucceed(defaultData.succeed) }}</Col>
          </Row>
          <Row>
            <Col span="5" class="left-label">和解协议：</Col>
            <Col span="16" class="right-content">
              <file-upload
                :default-list="defaultData.attachmentList || []"
                :upload-config="{readOnly:true}"
              />
            </Col>
          </Row>
        </template>
        <template v-else>
          <template v-if="agreementVO">
            <Row><Col span="5" class="left-label">和解类型：</Col><Col span="16" class="right-content">线上</Col></Row>
            <Row><Col span="5" class="left-label">和解对象：</Col><Col span="16" class="right-content">{{ (agreementVO.litigantIdsName && agreementVO.litigantIdsName.join(' ') ) || "" }}</Col></Row>
            <Row>
              <Col span="5" class="left-label">和解金额(元):</Col>
              <Col span="16" class="right-content">{{ common.formateNumber(agreementVO.amount) }}</Col>
            </Row>
            <Row v-if="defaultData.lowUnitPriceFlag" style="color: red">
              <Col span="5" class="left-label" />
              <Col span="16" class="right-content">*此金额低于行业客单价目标值</Col>
            </Row>
            <Row><Col span="5" class="left-label">违约金(元):</Col><Col span="16" class="right-content">
              {{ common.formateNumber(agreementVO.liquidatedDamages) }}
            </Col></Row>
            <Row><Col span="5" class="left-label">收款方：</Col><Col span="16" class="right-content">
              <template v-if="agreementVO.collectionType && agreementVO.collectionType == 'A'">安盾</template>
              <template v-if="agreementVO.collectionType && agreementVO.collectionType == 'C'">客户</template></Col></Row>
            <Row><Col span="5" class="left-label">付款期限：</Col><Col span="16" class="right-content">{{ agreementVO.termsPayment || "" }}</Col></Row>
            <Row><Col span="5" class="left-label">停止侵权期限：</Col><Col span="16" class="right-content">{{ agreementVO.termsInfringement || "" }}</Col></Row>
            <Row><Col span="5" class="left-label">乙方签署人身份：</Col><Col span="16" class="right-content">
              <template v-if="agreementVO.identitySignatory && agreementVO.identitySignatory == 'P'">个人</template>
              <template v-if="agreementVO.identitySignatory && agreementVO.identitySignatory == 'I'">直系亲属</template>
              <template v-if="agreementVO.identitySignatory && agreementVO.identitySignatory == 'A'">诉讼代理人</template>
            </Col></Row>
            <Row><Col span="5" class="left-label">乙方签署人：</Col><Col span="16" class="right-content">{{ agreementVO.signatory || "" }}</Col></Row>
            <Row><Col span="5" class="left-label">乙方签署人联系方式：</Col><Col span="16" class="right-content">{{ agreementVO.mobile || "" }}</Col></Row>
            <Row><Col span="5" class="left-label">签署状态：
            </Col><Col span="16" class="right-content">
              {{ agreementVO.signStateName }}
            </Col>
            </Row>
            <!-- 和解结果详情 -->
            <Row v-if="defaultData.auditState">
              <Col span="5" class="left-label">审核结果：</Col>
              <Col span="16" class="right-content">
                <Tag style="border-radius:11px;" :color="getTagColor(defaultData.auditState)">{{ defaultData.auditStateName }}</Tag>
              </Col>
            </Row>
            <Row>
              <Col span="5" class="left-label">和解结果：</Col>
              <Col span="16" class="right-content">{{ defaultData.succeed?"成功":"失败" }}</Col>
            </Row>
            <Row>
              <Col span="5" class="left-label">和解协议：</Col>
              <Col span="16" class="right-content">
                <file-upload
                  :href-url="true"
                  :default-list="defaultData.attachmentList || []"
                  :upload-config="{readOnly:true}"
                />
              </Col>
            </Row>
          </template>
          <template v-else>
            暂无信息
          </template>
        </template>
      </Row>

    </Row>
    <Row v-if="defaultData && defaultData.source && payInfoData.amount" class="case-content">
      <Row class="detail-content">
        <template>
          <Row>
            <Col span="5" class="left-label">付款金额：</Col>
            <Col span="16" class="right-content">{{ payInfoData.amount }}</Col>
          </Row>
          <Row>
            <Col span="5" class="left-label">付款人：</Col>
            <Col span="16" class="right-content">{{ payInfoData.drawee }}</Col>
          </Row>
          <Row>
            <Col span="5" class="left-label">付款时间：</Col>
            <Col span="16" class="right-content">{{ payInfoData.paymentTime }}</Col>
          </Row>
          <Row>
            <Col span="5" class="left-label">付款凭证：</Col>
            <Col span="16" class="right-content">
              <file-upload
                :default-list="payInfoData.attachment || []"
                :upload-config="{ readOnly: true }"
              />
            </Col>
          </Row>
        </template>
      </Row>
    </Row>
  </div>
</template>
<script>
import styles from '@/assets/globalStyle.scss'
export default {
  props: ['processId', 'caseId', 'nodeId', 'caseState', 'tabActive', 'nodeNextId', 'prevCode', 'prevProcessId', 'isButtonClick'],
  data () {
    const overMillion = (rule, value, callback) => {
      if (Number(value) > 100000000) {
        return callback(new Error('金额不能超过一亿'))
      }
      callback()
    }
    return {
      styles: styles,
      infoCtrl: false,
      isDetailLoad: false,
      isSubmit: false,
      defaultList: [],
      litigantIdArr: [],
      defaultData: '',
      formData: {
        selectIdArr: [],
        litigantIds: '',
        content: '',
        amount: '',
        litigantNames: '',
        attachmentList: [],
        auditRemark: '',
        succeed: '',
        nodeData: ''
      },
      nodeList: [],
      nodeReduceData: [],
      ruleValidate: {
        selectIdArr: [{ required: true, type: 'array', message: '和解对象不能为空', trigger: 'blur' }],
        content: [{ required: true, message: '和解内容不能为空', trigger: 'blur' }, { max: 512, message: '不能超过512个字符', trigger: 'blur' }],
        amount: [{ required: true, message: '和解金额不能为空', trigger: 'blur' }, { validator: overMillion, trigger: 'blur' }],
        nodeData: [{ required: true, type: 'number', message: '请选择节点', trigger: 'change' }]
      },
      agreementVO: null,
      isShowAmountTip: false,
      averageAmount: 0,
      payInfoData: {
        amount: '',
        drawee: '',
        paymentTime: '',
        attachment: []
      }
    }
  },
  watch: {
    isButtonClick(nV, oV) {
      console.log(nV, oV)
      if (nV) {
        this.defaultData = ''
        this.infoCtrl = false
        this.defaultList = []
        Object.keys(this.formData).forEach(key => {
          if (key !== 'selectIdArr' && key !== 'attachments') {
            this.$set(this.formData, key, '')
          } else {
            this.$set(this.formData, key, [])
          }
        })
      } else {
        this.getDetail()
      }
    }
  },
  created() {
    console.log('nodeId', this.nodeId)
  },
  beforeMount() {
    this.getNodeData()
    this.getAverageAmount()
    this.getLitigantIdArr()
    this.isButtonClick ? this.isDetailLoad = true : this.getDetail()
    this.getReconcile()
  },
  mounted() {},
  updated() {},
  methods: {
    edit() {
      this.infoCtrl = false
      // if (this.defaultData.source) this.giveOnLineDefaultData()
    },
    getSucceed(data) {
      if (data == null) {
        return ''
      } else if (data == 1) {
        return '成功'
      } else {
        return '失败'
      }
    },
    getNodeData() {
      const url = '/business/case/process/optional?optional=1&caseId=' + this.caseId
      this.$get(url).then(res => {
        if (res.code == 0) {
          this.nodeReduceData = res.data
        }
      })
    },
    // 选择节点
    changeNode(data) {
      console.log(data, 'data')
      this.formData.nodeData = data
    },

    getAttachmentList(daraArr) {
      this.formData.attachmentList = []
      daraArr.forEach((item, index) => {
        const obj = {
          fileName: item.fileName,
          mediaType: item.mediaType,
          smallUrl: item.smallUrl,
          url: item.url
        }
        this.formData.attachmentList.push(obj)
      })
    },
    // 获取和解详情
    getDetail() {
      const url = '/business/case/reconcile/' + this.processId
      this.$get(url).then(async (res) => {
        if (res.code === 0 && res.data) {
          this.defaultData = res.data
          if (res.data.source) {
            const agreementVO = this.defaultData.agreementVO
            if (agreementVO) {
              const { data: targetList } = await this.$get(`/business/litigants/${res.data.caseId}/reconcile`)
              const litigantIdsName = []
              // targetList.find(r=> r.id ===  this.agreementVO.)
              for (let i = 0; i < targetList.length; i++) {
                for (let j = 0; j < agreementVO.litigantIds.length; j++) {
                  if (targetList[i].id == agreementVO.litigantIds[j]) {
                    litigantIdsName.push(targetList[i].name)
                    break
                  }
                }
              }
              agreementVO.litigantIdsName = litigantIdsName
              this.agreementVO = agreementVO
            }
          }
          this.infoCtrl = true
          this.giveDefaultData()
        } else {
          this.isDetailLoad = true
        }
      })
    },
    // 获取和解信息
    getReconcile() {
      const url = `/business/reconcile/payment-record/${this.caseId}`
      this.$get(url).then(res => {
        if (res.code == 0 && res.data !== null) {
          this.payInfoData.amount = res.data.amount
          this.payInfoData.drawee = res.data.drawee
          this.payInfoData.paymentTime = res.data.paymentTime
          this.payInfoData.attachment.push(res.data.attachment)
        }
      })
    },
    giveOnLineDefaultData() {
      this.formData.content = this.defaultData.content
      if (this.formData.succeed != null) {
        this.formData.succeed = this.defaultData.succeed ? 1 : 0
      }
      const arr = this.agreementVO.litigantIds ? this.agreementVO.litigantIds : []
      this.formData.selectIdArr = []
      arr.forEach((item, index) => {
        this.formData.selectIdArr.push(Number(item))
      })
      this.formData.litigantIds = this.agreementVO.litigantIds
      this.formData.amount = this.agreementVO.amount + ''
      this.formData.nodeData = this.agreementVO.prevNodeIndex
      // content、litigantNames、succeed
      if (this.agreementVO.attachmentList && this.agreementVO.attachmentList.length > 0) {
        this.agreementVO.attachmentList.forEach((item, index) => {
          const obj = {
            fileName: item.fileName,
            mediaType: item.mediaType,
            smallUrl: item.smallUrl,
            url: item.url
          }
          this.formData.attachmentList.push(obj)
        })
      }
    },
    giveDefaultData() {
      const arr = this.defaultData.litigantIds ? this.defaultData.litigantIds.split(',') : []
      this.formData.selectIdArr = []
      arr.forEach((item, index) => {
        this.formData.selectIdArr.push(Number(item))
      })
      this.formData.litigantIds = this.defaultData.litigantIds
      this.formData.content = this.defaultData.content
      this.formData.amount = this.defaultData.amount + ''
      this.formData.litigantNames = this.defaultData.litigantNames
      this.formData.nodeData = this.defaultData.prevNodeIndex
      this.formData.attachmentList = []
      this.defaultList = this.defaultData.attachmentList || []
      if (this.formData.succeed != null) {
        this.formData.succeed = this.defaultData.succeed ? 1 : 0
      }
      if (this.defaultData.attachmentList && this.defaultData.attachmentList.length > 0) {
        this.defaultData.attachmentList.forEach((item, index) => {
          const obj = {
            fileName: item.fileName,
            mediaType: item.mediaType,
            smallUrl: item.smallUrl,
            url: item.url
          }
          this.formData.attachmentList.push(obj)
        })
      }

      this.isDetailLoad = true
    },
    getInputValue(value, key) {
      this.formData[key] = value
      this.checkAmount(value)
    },
    checkAmount(value) {
      if (Number(value) < this.averageAmount) {
        this.isShowAmountTip = true
      } else {
        this.isShowAmountTip = false
      }
    },
    // 获取行业客户单价目标值
    getAverageAmount() {
      const url = '/business/case/checkUnitPrice/' + this.caseId
      this.$post(url).then((res) => {
        if (res.code === 0) {
          this.averageAmount = res.data
        } else {
          this.$Message.warning(res.message || '请求错误')
        }
      })
    },
    getSelectValue(arr) {
      this.formData.litigantIds = ''
      this.formData.litigantNames = ''
      arr.forEach((item, index) => {
        this.formData.litigantIds += index == 0 ? item.value : `,${item.value}`
        this.formData.litigantNames += index == 0 ? item.label : `,${item.label}`
      })
    },
    // 获取对方当事人
    getLitigantIdArr() {
      const url = `/business/litigants/${this.caseId}/reconcile`
      this.$get(url).then(res => {
        if (res.code === 0) {
          this.litigantIdArr = res.data || []
        }
      })
    },
    getTagColor(state) {
      const obj = {
        'P': styles.warningColor,
        'E': styles.successColor,
        'R': styles.errorColor
      }
      return obj[state]
    },
    // 提交
    submitNew() {
      // const url = '/business/case/reconcile'
      const url = '/business/case/reconcile/mini'

      const ajaxData = {
        // processId: this.processId,
        caseId: this.caseId
      }

      if (this.defaultData) {
        // 审核驳回修改和解申请信息
        ajaxData.id = this.defaultData.id
        ajaxData.litigantIds = this.formData.litigantIds
        ajaxData.litigantNames = this.formData.litigantNames
        ajaxData.content = this.formData.content
        ajaxData.amount = this.formData.amount
        ajaxData.succeed = this.formData.succeed
        ajaxData.attachmentList = this.formData.attachmentList
        ajaxData.prevNodeIndex = this.formData.nodeData
        // ajaxData.processId = this.formData.nodeData

        this.$refs['formData'].validate((valid) => {
          if (valid) {
            this.isSubmit = true
            this.$post(url, ajaxData).then(res => {
              if (res.code === 0) {
                this.getDetail()
                this.$emit('reloadProcess')
                this.$Message.success('操作成功')
              } else {
                this.$Message.error(res.message)
              }
              this.isSubmit = false
            })
          }
        })
      } else {
        if (this.formData.nodeData && this.formData.nodeData !== '') {
          this.nodeReduceData.forEach(item => {
            if (item.nodeIndex == this.formData.nodeData) {
              ajaxData.processId = item.processId
            }
          })
        }

        // 新增和解基本信息
        ajaxData.litigantIds = this.formData.litigantIds
        ajaxData.litigantNames = this.formData.litigantNames
        ajaxData.content = this.formData.content
        ajaxData.amount = this.formData.amount
        ajaxData.nodeId = this.nodeId
        ajaxData.succeed = this.formData.succeed
        ajaxData.attachmentList = this.formData.attachmentList
        ajaxData.prevNodeIndex = this.formData.nodeData
        // ajaxData.processId = this.formData.nodeData

        this.$refs['formData'].validate((valid) => {
          if (valid) {
            this.isSubmit = true
            this.$post(url, ajaxData).then(res => {
              if (res.code === 0) {
                this.$emit('reloadProcess')
                this.$Message.success('操作成功')
              } else {
                this.$Message.error(res.message)
              }
              this.isSubmit = false
              this.getDetail()
            })
          }
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../caseCommon.scss';
.litigant-info{
    width:100%;
}
</style>



// WEBPACK FOOTER //
// src/view/civilCase/listOptions/compromise.vue